import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from 'assets/v2/logo-new.svg'
import _imports_1 from 'assets/v2/app-icon-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-5292c999"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gt-sm" }
const _hoisted_2 = ["data-testid", "onClick"]
const _hoisted_3 = {
  key: 2,
  class: "row"
}
const _hoisted_4 = {
  key: 1,
  class: "flex column text-center"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "weather-subtitle" }
const _hoisted_7 = { class: "row justify-center items-center no-wrap" }
const _hoisted_8 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_PointsIndicator = _resolveComponent("PointsIndicator")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "q-px-md-xl q-px-md q-py-md row justify-between" }, {
    default: _withCtx(() => [
      (!_ctx.$q.platform.is.capacitor)
        ? (_openBlock(), _createBlock(_component_q_img, {
            key: 0,
            class: _normalizeClass(["logo", { invisible: !_ctx.showLogo && !_ctx.$q.screen.lt.md }]),
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: _ctx.ROUTES.HOME })))
          }, null, 8, ["class"]))
        : (_openBlock(), _createBlock(_component_q_img, {
            key: 1,
            class: "logo-capacitor",
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: _ctx.ROUTES.HOME })))
          })),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerLinks, (headerLink) => {
          return (_openBlock(), _createElementBlock("h6", {
            key: headerLink.routeName,
            "data-testid": headerLink.dataTestId,
            class: "header-link forward-on-hover q-mx-lg-xl q-mx-lg text-capitalize cursor-pointer",
            onClick: _withModifiers(headerLink.action, ["prevent"])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getRoutePath(headerLink.routeName as string) ? 'a' : 'span'), {
              href: _ctx.getRoutePath(headerLink.routeName as string)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(headerLink.text), 1)
              ]),
              _: 2
            }, 1032, ["href"]))
          ], 8, _hoisted_2))
        }), 128))
      ]),
      (_ctx.$q.platform.is.capacitor && _ctx.$route.name === _ctx.ROUTES.HOME)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.loadingWeatherData)
              ? (_openBlock(), _createBlock(_component_q_spinner_dots, {
                  key: 0,
                  size: "50px"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.weatherDataString)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "weather-title",
                        innerHTML: _ctx.weatherDataString
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.timeData), 1)
                ]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.$q.platform.is.capacitor)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              "data-testid": _ctx.dataTestIds.HEADER.ANIMALS_HELPED,
              class: "animals-saved-wrapper flex"
            }, _toDisplayString(Math.trunc(_ctx.points / 45)) + " " + _toDisplayString(_ctx.$t('animalsHelped')), 9, _hoisted_8))
          : _createCommentVNode("", true),
        (!_ctx.$q.platform.is.capacitor)
          ? (_openBlock(), _createBlock(_component_PointsIndicator, {
              key: 1,
              "data-testid": _ctx.dataTestIds.HEADER.POINTS_INDICATOR,
              class: "q-mx-lg"
            }, null, 8, ["data-testid"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "row hamburger lt-md bg-white",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showDrawer')))
        }, [
          _createVNode(_component_AppIcon, {
            name: "bars",
            width: 16,
            height: 16
          })
        ])
      ])
    ]),
    _: 1
  }))
}